import { Container, Row, Col, Image } from "react-bootstrap";
import { Bounce } from "react-reveal";
import { StyledSection, StyledCover } from "./health-facalities-screen-styles";
import Image1 from "../../assets/images/health1.jpg";
import Image2 from "../../assets/images/health2.jpg";
import Image3 from "../../assets/images/health3.jpg";

const healthFacilitiesScreen = () => {
  return (
    <>
      <StyledSection>
        <Container fluid="md">
          <div className="header-text">
            <Bounce left>
              <h1 className="text-center">
                A much easier way to order your medical supplies
              </h1>
            </Bounce>
          </div>
          <Row className="align-items-center gx-5 gy-5">
            <Col xs={12} sm={12} md={7}>
              <Image src={Image1} alt="image1" fluid />
            </Col>
            <Col xs={12} sm={12} md={5}>
              <h2>Create an account and start ordering your supplies</h2>
              <p className="mt-5">
                Have access to all the suppliers on the platform.
              </p>
            </Col>
          </Row>
          <Row className="align-items-center mt-5 gx-5 gy-5">
            <Col xs={12} sm={12} md={5}>
              <h2>Make online payments and get instant deliveries </h2>
              <p className="mt-5">
                Track your order from supplier to your facility.
              </p>
            </Col>
            <Col xs={12} sm={12} md={7}>
              <Image src={Image2} alt="image1" width="100%" height="auto" />
            </Col>
          </Row>
        </Container>
      </StyledSection>

      <StyledCover>
        <div className="barr">
          <h1 className="bar-text">By using our platform...</h1>
        </div>
        <div className="cover-image">
          <ul>
            <li style={{ width: "70%" }}>
              Save on money by comparing live prices from suppliers
            </li>
            <li>Save on time by spending less on ordering</li>
            <li>Buy from reliable suppliers</li>
          </ul>
        </div>
      </StyledCover>
      <StyledSection>
        <Container>
          <Row className="align-items-center mt-5 gx-5 gy-5">
            <Col xs={12} sm={12} md={7}>
              <Image src={Image3} alt="image1" width="100%" height="auto" />
            </Col>
            <Col xs={12} sm={12} md={5}>
              <h2>Keep a record of your purchases and track your expenses.</h2>
              <p className="mt-5">
                Have acces to our financial spreadsheets to better manage your
                account.
              </p>
            </Col>
          </Row>
        </Container>
      </StyledSection>
    </>
  );
};

export default healthFacilitiesScreen;
